    //Shore Club Signup Join Now CTA button
  var joinNowCta = document.querySelectorAll('.shoreclub .shoreclub__content a.shoreclub__btn');
  joinNowCta.forEach((cta) => {
      cta.addEventListener('click', function (e) {
          const buttonText = this.textContent.trim();
          const clickUrl = this.href;
          var contentName= 'shoreclub_signup';
          // Push to dataLayer
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
              event: 'click_interaction',
              click_text: buttonText,
              click_url: clickUrl || '',
              content_name: contentName,
              type: 'CTA Button',
          });
      });
  });

//Shop All Teddy Swims CTA button PDP Page
  var recoCta = document.querySelectorAll('.reco-footer a.reco-btn');
  recoCta.forEach((cta) => {
      cta.addEventListener('click', function (e) {
          const recobuttonText = this.textContent.trim();
          const recoclickUrl = this.href;
          var contentName= 'PDP';
          // Push to dataLayer
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
              event: 'click_interaction',
              click_text: recobuttonText,
              click_url: recoclickUrl || '',
              content_name: contentName,
              type: 'CTA Button',
          });
      });
  });

  // click_interaction | details
  document.addEventListener('DOMContentLoaded', function () {

  const summaries = document.querySelectorAll('#mc-cartDrawer details summary');

  summaries.forEach((summary) => {

    summary.addEventListener('click', function () {
      // skip data layer event click if according is going to close D2C-2888
      const details = summary.closest('details');
      if (details && details.open) return; // already open = user is closing, skip 

      const title = summary.querySelector('.drawer-accordion__title')?.innerText.trim();

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'click_interaction',
        click_text: title,
        click_url: window.location.origin + window.location.pathname,
        content_name: 'PDP',
        type: 'details'
      });

      //console.log('Accordion clicked:', title);

    });

  });

});

// Header Navigation menu
var headernavigationMenu = document.querySelectorAll('header.header .list-menu a.list-menu__item, header.header .mega-menu a.mc-menu-view-all, header.header .mega-menu a.mm-products-container__cta-link-text, header.header .mega-menu a.mega-menu__link, .mega-menu a.mega-menu__link,.mega-menu a.mega-menu__link, #menu-drawer .child-item a.menu-link, #menu-drawer .child-item .mc-dropdown-sub a');
headernavigationMenu.forEach((cta) => {
    cta.addEventListener('click', function (e) {
        //var clickUrl = this.getAttribute('href');      
        var clickUrl = this.href; // full URL D2C-2894
        // Get text inside the <span>, fallback to anchor text if <span> not present
        var anchorText = this.querySelector('p,span') 
            ? this.querySelector('p,span').textContent.trim() 
            : this.textContent.trim();

        var contentName = 'header';

        // Push to dataLayer
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'click_interaction',
            click_text: anchorText,
            click_url: clickUrl || '',
            content_name: contentName,
            type: 'navigation',
        });
    });
});

// Footer Navigation menu
var footernavigationMenu = document.querySelectorAll('.footer-block--menu a.list-menu__item');
footernavigationMenu.forEach((cta) => {
    cta.addEventListener('click', function (e) {
        //var footerclickUrl = this.getAttribute('href'); 
        var footerclickUrl = this.href; // full URL D2C-2894      
        
        // Get text inside the <span>, fallback to anchor text if <span> not present
        var footeranchorText = this.querySelector('p,span') 
            ? this.querySelector('p,span').textContent.trim() 
            : this.textContent.trim();

        var footercontentName = 'footer';

        // Push to dataLayer
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'click_interaction',
            click_text: footeranchorText,
            click_url: footerclickUrl || '',
            content_name: footercontentName,
            type: 'navigation',
        });
    });
});

  // Tracking datalayer events for select_item from PDP MORE IN THE ICONIC COLLECTION
const pdpcollectionItems = document.querySelectorAll('.reco-container .reco-grid a');

pdpcollectionItems.forEach(item => {
    item.addEventListener('click', function (e) {

      const productItem = {
          item_id: String(item.getAttribute('data-product-id') || ''),
          item_name: item.getAttribute('data-product-name') || '',
          price: Number(parseFloat(item.getAttribute('data-product-price')) || 0),
          item_brand: 'White Claw US Merch',
          item_category: item.getAttribute('data-product-category'),
          item_list_name: item.getAttribute('data-item-list-name') || '',
          index: parseInt(item.getAttribute('data-index'), 10) || 0
        };

        const variantTitle = item.getAttribute('data-variant-title');
        if (variantTitle && variantTitle !== 'Default Title') {
            productItem.item_variant = variantTitle;
        }

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
           event: 'select_item',
           ecommerce: {
              currency: Shopify.currency.active,
              value: Number(parseFloat(item.getAttribute('data-product-price')) || 0),
              items: [productItem]
            }
        });
    });
});

// Tracking datalayer events for select_item
document.addEventListener('click', function (e) {
  const item = e.target.closest('.card__content a');
  if (!item) return;
  const parentLi = item.closest('li');
  const variantTitle = item.getAttribute('data-variant-title');
  const productItem = {
    item_id: String(item.getAttribute('data-product-id') || ''),
    item_name: item.getAttribute('data-product-name') || '',
    price: Number(parseFloat(item.getAttribute('data-product-price')) || 0),
    item_brand: 'White Claw US Merch',
    item_category: item.getAttribute('data-product-category') || '',
    item_list_name: item.getAttribute('data-item-list-name') || '',
    index: parseInt(parentLi?.getAttribute('data-index'), 10) || 0
  };

  // Add only if variant exists
  if (variantTitle && variantTitle !== 'Default Title') {
    productItem.item_variant = variantTitle;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
      event: 'select_item',
      ecommerce: {
        currency: Shopify.currency.active,
        value: Number(parseFloat(item.getAttribute('data-product-price')) || 0),
        items: [productItem]
    }
  });


  const badgeName = item.getAttribute('data-badge-name');
  // Check if the attribute exists and is not an empty string
  if (badgeName && badgeName.trim() !== "") {

    const promotionItem = {
      item_id: String(item.getAttribute('data-product-id') || ''),
      item_name: item.getAttribute('data-product-name') || '',
      price: Number(parseFloat(item.getAttribute('data-product-price')) || 0),
      item_brand: 'White Claw US Merch',
      item_category: item.getAttribute('data-product-category') || '',
      item_list_name: item.getAttribute('data-item-list-name') || '',
      index: parseInt(parentLi?.getAttribute('data-index'), 10) || 0
    };

    if (variantTitle && variantTitle !== 'Default Title') {
      promotionItem.item_variant = variantTitle;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "select_promotion",
      ecommerce: {
        promotion_id: item.getAttribute('data-badge-id'),
        promotion_name: badgeName,
        creative_name: "plp_here",
        creative_slot: parseInt(parentLi?.getAttribute('data-index'), 10) || 0,
        items: [promotionItem]
      }
    });
  }
});

// view_promotion 
// Persist across filters
const firedPromotions = new Set();

function initPromotionObserver() {
  const items = document.querySelectorAll('#product-grid li'); // correct root

  if (!items.length) {
    //console.log('No product items found');
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;

      const li = entry.target;

      // 🔥 Try li first, then fallback to child
      const badgeEl = li.querySelector('[data-badge-name]') || li;

      const badgeName = badgeEl.getAttribute('data-badge-name');
      const promoId = badgeEl.getAttribute('data-badge-id');

      if (!badgeName) return;

      const productId = li.getAttribute('data-product-id') || badgeEl.getAttribute('data-product-id');

      const uniqueKey = promoId + '_' + productId;
      const promotionItem = {
        item_id: String(productId || ''),
        item_name: li.getAttribute('data-product-name') || badgeEl.getAttribute('data-product-name') || '',
        price: Number(
          parseFloat(
            li.getAttribute('data-product-price') ||
            badgeEl.getAttribute('data-product-price')
          ) || 0
        ),
        item_brand: 'White Claw US Merch',
        item_category:
          li.getAttribute('data-product-category') ||
          badgeEl.getAttribute('data-product-category') ||
          '',
        item_list_name: li.getAttribute('data-item-list-name') || '',
        index: parseInt(li.getAttribute('data-index'), 10) || 0
      };

      if (firedPromotions.has(uniqueKey)) {
        observer.unobserve(li);
        return;
      }

      firedPromotions.add(uniqueKey);

      //console.log('✅ view_promotion fired:', uniqueKey);

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "view_promotion",
        ecommerce: {
          promotion_id: promoId,
          promotion_name: badgeName,
          creative_name: "plp_here",
          creative_slot: parseInt(li.getAttribute('data-index'), 10) || 0,
          items: [promotionItem]
        }
      });

      observer.unobserve(li);
    });
  }, {
    threshold: 0.1
  });

  items.forEach(li => observer.observe(li));
}

// Initial load
document.addEventListener("DOMContentLoaded", initPromotionObserver);

// 🔥 Reliable re-init after filters (covers all themes)
const mutationObserver = new MutationObserver(() => {
  initPromotionObserver();
});

mutationObserver.observe(document.body, {
  childList: true,
  subtree: true
});

//filter_interaction on PLP

(function() {
  function trackFilter(group, value, type, interactionType) {
    if (!value) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "filter_interaction",
      filter_option: group?.toLowerCase(),
      filter_value: value,
      filter_type: type,
      type: interactionType
    });
  }

  // --- 1. DESKTOP LOGIC (Immediate) comment D2C-2888---
  // document.addEventListener("DOMContentLoaded", function() {
  //   document.querySelectorAll('#FacetFiltersForm input[type="checkbox"]:checked').forEach(input => {
  //     const group = input.closest(".facets__disclosure")?.querySelector(".facets__summary-label")?.innerText.trim();
  //     const value = input.closest(".facets__item")?.querySelector(".facet-checkbox__text-label")?.innerText.trim();
  //     trackFilter(group, value, "default", "filter");
  //   });

  //   const sortSelect = document.querySelector("#SortBy");
  //   if (sortSelect) {
  //     trackFilter("sort", sortSelect.options[sortSelect.selectedIndex].text.trim(), "default", "sort");
  //   }
  // });

  document.addEventListener("change", function(e) {
    const filterInput = e.target.closest('#FacetFiltersForm input[type="checkbox"]');
    if (filterInput && filterInput.checked) {
      const group = filterInput.closest(".facets__disclosure")?.querySelector(".facets__summary-label")?.innerText.trim();
      const value = filterInput.closest(".facets__item")?.querySelector(".facet-checkbox__text-label")?.innerText.trim();
      trackFilter(group, value, "user_selection", "filter");
    }

    if (e.target.matches("#SortBy")) {
      trackFilter("sort", e.target.options[e.target.selectedIndex].text.trim(), "user_selection", "sort");
    }
  });


  // --- 2. MOBILE LOGIC (Staged until Apply) ---
  let mobileSessionSelections = new Set(); 
  let mobileStagedSort = null; // Holds sort value until Apply is clicked

  function getMobileFilterData(checkbox) {
    const value = checkbox.closest('.mobile-facets__item')?.querySelector('.facet-checkbox__text-label')?.innerText.trim();
    const submenu = checkbox.closest('.mobile-facets__submenu');
    const group = submenu?.querySelector('.mobile-facets__close-button span')?.innerText.trim() || 
                  checkbox.closest('.mobile-facets__details')?.querySelector('.mobile-facets__summary span')?.innerText.trim() || 
                  'unknown';
    return { group: group.toLowerCase(), value: value };
  }

  document.addEventListener("change", function(e) {
    // Stage Checkboxes
    const mobileInput = e.target.closest('#FacetFiltersFormMobile input[type="checkbox"]');
    if (mobileInput && mobileInput.checked) {
      const data = getMobileFilterData(mobileInput);
      if (data.value) {
        mobileSessionSelections.add(JSON.stringify(data));
      }
    }

    // Stage Sort (Do NOT fire event yet)
    const mobileSort = e.target.closest('#FacetFiltersFormMobile select[name="sort_by"]');
    if (mobileSort) {
      mobileStagedSort = mobileSort.options[mobileSort.selectedIndex].text.trim();
    }
  });

  // Mobile Apply Button
  document.addEventListener("click", function(e) {
    const applyBtn = e.target.closest('.mobile-facets__footer .button');
    
    if (applyBtn) {
      // 1. Fire staged filters
      mobileSessionSelections.forEach(filterStr => {
        const filter = JSON.parse(filterStr);
        trackFilter(filter.group, filter.value, 'user_selection', 'filter');
      });

      // 2. Fire staged sort (if changed)
      if (mobileStagedSort) {
        trackFilter("sort", mobileStagedSort, "user_selection", "sort");
      }

      // Clear stages for next interaction
      mobileSessionSelections.clear();
      mobileStagedSort = null;
    }
    
    // Reset if "Clear All" is clicked
    if (e.target.closest('.mobile-facets__clear-all')) {
        mobileSessionSelections.clear();
        mobileStagedSort = null;
    }
  });
})();

// (function() {
//   function trackFilter(group, value, type, interactionType) {
//     // Only push if a value exists (prevents blanks)
//     if (!value) return;

//     window.dataLayer = window.dataLayer || [];
//     window.dataLayer.push({
//       event: "filter_interaction",
//       filter_option: group?.toLowerCase(),
//       filter_value: value,
//       filter_type: type,
//       type: interactionType
//     });
//   }

//   // 1. INITIAL LOAD: Track only what is already checked
//   document.addEventListener("DOMContentLoaded", function() {
//     const activeFilters = document.querySelectorAll('#FacetFiltersForm input[type="checkbox"]:checked');
//     activeFilters.forEach(input => {
//       const group = input.closest(".facets__disclosure")?.querySelector(".facets__summary-label")?.innerText.trim();
//       const value = input.closest(".facets__item")?.querySelector(".facet-checkbox__text-label")?.innerText.trim();
//       trackFilter(group, value, "default", "filter");
//     });

//     const sortSelect = document.querySelector("#SortBy");
//     if (sortSelect) {
//       trackFilter("sort", sortSelect.options[sortSelect.selectedIndex].text.trim(), "default", "sort");
//     }
//   });

//   // 2. USER INTERACTION: Track ONLY when checked (applied)
//   document.addEventListener("change", function(e) {
//     const filterInput = e.target.closest('#FacetFiltersForm input[type="checkbox"]');
    
//     // Check if it's a filter AND if it was just turned ON
//     if (filterInput && filterInput.checked) {
//       const group = filterInput.closest(".facets__disclosure")?.querySelector(".facets__summary-label")?.innerText.trim();
//       const value = filterInput.closest(".facets__item")?.querySelector(".facet-checkbox__text-label")?.innerText.trim();
//       trackFilter(group, value, "user_selection", "filter");
//     }

//     if (e.target.matches("#SortBy")) {
//       trackFilter("sort", e.target.options[e.target.selectedIndex].text.trim(), "user_selection", "sort");
//     }
//   });
// })();

// // For Mobile:

// (function() {
//   // Global variable to hold the currently checked filters
//   window.stagedMobileFilters = [];

//   // Robust function to find Group and Value names from a checkbox
//   function getFilterData(checkbox) {
//     // 1. Find the Value: Look for the text label next to/near the checkbox
//     const valueElement = checkbox.closest('.mobile-facets__item')?.querySelector('.facet-checkbox__text-label');
//     const value = valueElement ? valueElement.innerText.trim() : null;

//     // 2. Find the Group: Look for the heading of the specific submenu section
//     // In Shopify Dawn mobile, this is usually in the button that closes the submenu
//     const submenu = checkbox.closest('.mobile-facets__submenu');
//     const groupElement = submenu?.querySelector('.mobile-facets__close-button span');
    
//     // Fallback: If not in a submenu button, look for the summary text in the parent details
//     const fallbackGroup = checkbox.closest('.mobile-facets__details')?.querySelector('.mobile-facets__summary span')?.innerText.trim();
    
//     const group = (groupElement ? groupElement.innerText.trim() : fallbackGroup) || 'unknown';

//     return { group: group.toLowerCase(), value: value };
//   }

//   // Update our global variable whenever a checkbox is toggled
//   function updateStagedFilters() {
//     const selected = [];
//     const checkedInputs = document.querySelectorAll('#FacetFiltersFormMobile input[type="checkbox"]:checked');
    
//     checkedInputs.forEach(input => {
//       const data = getFilterData(input);
//       if (data.value) {
//         selected.push(data);
//       }
//     });

//     window.stagedMobileFilters = selected;
//   }

//   // 1. Listen for checkbox changes to update the global variable
//   document.addEventListener("change", function(e) {
//     if (e.target.closest('#FacetFiltersFormMobile input[type="checkbox"]')) {
//       updateStagedFilters();
//     }
//   });

//   // 2. Trigger individual dataLayer events when 'Apply' is clicked
//   document.addEventListener("click", function(e) {
//     const applyBtn = e.target.closest('.mobile-facets__footer .button');
    
//     if (applyBtn) {
//       window.dataLayer = window.dataLayer || [];
      
//       // Push each filter interaction as a separate event
//       window.stagedMobileFilters.forEach(filter => {
//         window.dataLayer.push({
//           event: 'filter_interaction',
//           filter_option: filter.group,
//           filter_value: filter.value,
//           filter_type: 'user_selection',
//           type: 'filter'
//         });
//       });
//     }
//   });

//   // Initial check on load
//   document.addEventListener("DOMContentLoaded", updateStagedFilters);
// })();

// Set values for item_list_name
document.addEventListener('click', function (e) {
  const link = e.target.closest('a[data-item-list-name]');
  if (link) {
    const listName = link.getAttribute('data-item-list-name');
    localStorage.setItem('item_list_name', listName);
    localStorage.setItem('item_list_name_for_add_to_cart', listName);

  } 
});

// Tracking event listeners to add_to_cart
const { fetch: originalFetch } = window;

window.fetch = async (...args) => {
    let [ resource, config ] = args;

    let response = await originalFetch(resource, config);

    if ( resource === '/cart/add' ) {
        response.clone().json().then((data) => trackAddToCart(data));
    }

    return response;
};


function trackAddToCart(data) {

    const productId = data.product_id;
    const newTotalQty = data.quantity;
    const variantId = data.variant_id; 
    // const productJson = data;
    //console.log(typeof data, data);
    // 1. Get the previous quantity from localStorage
    const storageKey = `cart_qty_${productId}_${variantId}`;
    const previousQty = parseInt(localStorage.getItem(storageKey)) || 0;
    const incrementalQty = newTotalQty - previousQty;
    
    // Find the variant data from the product's JSON
      let variant = null;
  if (typeof productJson !== 'undefined' && productJson.variants) {
    variant =
      productJson.variants.find(
        v => v.id.toString() === variantId.toString()
      ) || productJson.variants[0];
  }

    //alert(JSON.stringify(data, null, 2));
    const itemListName = localStorage.getItem('item_list_name_for_add_to_cart') || 'collections';
    // D2C-2895 Changes
    const itemPrice = Number((data.price / 100).toFixed(2));

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'add_to_cart',
        'ecommerce':  {
        'currency': Shopify.currency.active,
        'value': (data.price / 100).toFixed(2).toString() * incrementalQty,
        'items': [{
          'item_id': String(productId || ''),
          'item_name': data.title || '',
          'price': itemPrice,
          'quantity': incrementalQty,
          'item_brand': 'White Claw US Merch',
          'item_category': data.product_type || '',
          'item_variant': data.variant_title || null,
          'item_list_name': 'product_page',
        }]
  }
    });

// 4. Update localStorage with the current total so the next increment is calculated correctly
localStorage.setItem(storageKey, newTotalQty);
localStorage.removeItem('item_list_name_for_add_to_cart');
  }

// Tracking event listeners to view_cart with cart Drawer
(() => {

  document.getElementById('CartDrawer').addEventListener('click', function (event) {
      const button = event.target.closest('.quantity__button');
      if (button) {
          const inputId = button.getAttribute('data-input-id');
          const productId = button.getAttribute('data-product-id');
          const input = document.querySelector('[data-item-id="' + inputId + '"]');

          if (!input) return;

        const price = parseFloat(input.getAttribute('data-product-price'));
        const quantity = parseInt(input.value, 10);

        // Detect button type (increase or decrease)
        const isIncrease = button.name === 'plus' || button.classList.contains('button-plus');
        const isDecrease = button.name === 'minus' || button.classList.contains('button-minus');

        const productID = input.getAttribute('data-product-id');
        const variantID = input.getAttribute('data-variant-id');
        var storageKey = `cart_qty_${productID}_${variantID}`;
        // Fallback to 0 if the item doesn't exist in storage yet
        let previousTotalQty = parseInt(localStorage.getItem(storageKey), 10) || 0;
        let newTotalQty = previousTotalQty;
        const numericPrice = Number(
          parseFloat(input.getAttribute('data-product-price')) || 0
        );
        const metafields = window.metafields;
          window.dataLayer = window.dataLayer || [];
          if (isIncrease) {
            newTotalQty += 1;
            window.dataLayer.push({
                event: 'add_to_cart',
                ecommerce: {
                    currency: Shopify.currency.active,
                    value: price,
                    items: [{
                        item_id: String(input.getAttribute('data-product-id') || ''),
                        item_name: input.getAttribute('data-product-name'),
                        price: numericPrice,
                        item_brand: "White Claw US Merch",
                        item_category: input.getAttribute('data-product-category'),
                        item_variant: input.getAttribute('data-variant-title') === "Default Title" ? null : (input.getAttribute('data-variant-title') || null),
                        quantity: 1, // increment is always 1
                        item_list_name: 'cart',
                        index: parseInt(input.getAttribute('data-index')) - 1
                    }]
                }
            });
        }
          if (isDecrease && previousTotalQty > 0 && !event.target.closest('.cart-remove-button')) {             
            
              const variantTitle = input.getAttribute('data-variant-title');
              const item = {
                  item_id: String(input.getAttribute('data-product-id') || ''),
                  item_name: input.getAttribute('data-product-name'),
                  price: numericPrice,
                  item_brand: "White Claw US Merch",
                  item_category: input.getAttribute('data-product-category'),
                  quantity: 1,
                  item_list_name: 'cart',
                  index: parseInt(input.getAttribute('data-index'), 10) - 1
              };
              if (variantTitle && variantTitle !== "Default Title") {
                  item.item_variant = variantTitle;
              }
              window.dataLayer.push({
                  event: 'remove_from_cart',
                  ecommerce: {
                  currency: Shopify.currency.active,
                  value: parseFloat(input.getAttribute('data-product-price')),
                  items: [item]
                }   
              });
              newTotalQty = previousTotalQty - 1;
          }
    // If quantity becomes 0 or less → remove from storage
          if (newTotalQty <= 0) {
            localStorage.removeItem(storageKey);
          } else {
            localStorage.setItem(storageKey, newTotalQty.toString());
          }
      }

      const removeBtn = event.target.closest('.cart-remove-button');

      if (removeBtn) {
        const productID = removeBtn.getAttribute('data-product-id');
        const variantID = removeBtn.getAttribute('data-variant-id');
        const storageKey = `cart_qty_${productID}_${variantID}`;
        const unitPrice = Number(
          parseFloat(removeBtn.getAttribute('data-product-price')) || 0
        );

        const quantity = parseInt(
          removeBtn.getAttribute('data-product-quantity'),
          10
        ) || 1;
        
        const variantTitle = removeBtn.getAttribute('data-variant-title');
        const item = {
          item_id: String(productID || ''),
          item_name: removeBtn.getAttribute('data-product-name') || '',
          price: unitPrice,
          item_brand: "White Claw US Merch",
          item_category: removeBtn.getAttribute('data-product-category') || '',
          quantity: quantity,
          item_list_name: 'cart',
          index: (parseInt(removeBtn.getAttribute('data-index'), 10) || 1) - 1
        };

        if (variantTitle && variantTitle !== "Default Title") {
          item.item_variant = variantTitle;
        }

        window.dataLayer.push({
                  event: 'remove_from_cart',
                  ecommerce: {
                  currency: Shopify.currency.active,
                  value: unitPrice * quantity,
                  items: [item]
                }   
              });

        // Remove from storage completely
        localStorage.removeItem(storageKey);

        console.log(`Removed ${storageKey} from storage`);
      }
  });

  let lastCartHash = '';
  const cartDrawer = document.querySelector('cart-drawer');

  const observerCart = new MutationObserver(() => {
      if (cartDrawer.classList.contains('active')) {
        const skip = sessionStorage.getItem('skip_view_cart_drawer') === 'true';
        if (skip) {
          sessionStorage.removeItem('skip_view_cart_drawer');
          return;
        }
          const items = [];
          document.querySelectorAll('#CartDrawer .quantity__input').forEach((input, index) => {
              items.push({
                  item_id: input.getAttribute('data-product-id'),
                  item_name: input.getAttribute('data-product-name'),
                  price: parseFloat(input.getAttribute('data-product-price')),
                  quantity: parseInt(input.value),
                  item_brand: "White Claw US Merch",
                  item_category: input.getAttribute('data-product-category') || null,
                  item_variant: input.getAttribute('data-variant-id') === "Default Title" ? null : (input.getAttribute('data-variant-id') || null),
                  item_list_name: 'cart',
                  index: index
              });
          });

          const currentCartHash = JSON.stringify(items);
          if (currentCartHash === lastCartHash) return; // 🚫 prevent duplicate
          lastCartHash = currentCartHash;

          if (items.length > 0) {
            const totalText = document.querySelector('.totals__total-value')?.textContent || '';
            const totalAmount = parseFloat(totalText.replace(/[^0-9.]/g, '')); // 120.00
            //console.log(totalAmount);
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                event: "view_cart",
                ecommerce: {
                currency: Shopify.currency.active,
                value: totalAmount,
                items: items
          }
        });
          }
      // Wait a short delay to ensure checkout button is in the DOM
    setTimeout(() => {
      const checkoutBtn = document.getElementById('CartDrawer-Checkout');
      if (checkoutBtn) {
        // console.log('Attaching begin_checkout listener');
        checkoutBtn.addEventListener('click', () => {
          const totalText = document.querySelector('.totals__total-value')?.textContent || '';
          const totalAmount = parseFloat(totalText.replace(/[^0-9.]/g, ''));

          // console.log('Checkout button clicked. Pushing begin_checkout', { items, totalAmount });

          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: "begin_checkout",
            ecommerce: {
              currency: Shopify.currency.active,
              value: totalAmount,
              items: items
            }
          });
        }, { once: true });
      } else {
        console.warn('Checkout button not found');
      }
    }, 300);
  }
});
 observerCart.observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });      
  
})();

document.addEventListener('click', function(e) {
  const cartLink = e.target.closest('a[href="/cart"]');

  // Only run on checkout page
  const isCheckoutPage = window.location.pathname.includes('/checkouts');

  // Check if it's inside breadcrumb
  const isBreadcrumb = e.target.closest('.breadcrumb') || e.target.closest('.breadcrumbs');

  if (cartLink && isCheckoutPage && isBreadcrumb) {
    sessionStorage.setItem('skip_view_cart_drawer', 'true');
  }
});

// click_interaction | social icons (header & footer)
document.addEventListener('click', function (e) {
  const socialLink = e.target.closest('.list-social__link');
  if (!socialLink) return;

  // Derive the platform name from data-item, falling back to the visually-hidden text
  const platform =
    socialLink.dataset.item ||
    (socialLink.querySelector('.visually-hidden') || {}).innerText ||
    '';

  const clickText  = platform.trim().toLowerCase();
  const clickUrl   = socialLink.href || '';

  // Walk up to the <ul> to read the location tag (header / footer)
  const listEl      = socialLink.closest('[data-location]');
  const contentName = listEl ? listEl.dataset.location : 'unknown';

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event:        'click_interaction',
    click_text:   clickText,
    click_url:    clickUrl,
    content_name: contentName,
    type:         'social_media',
  });
});